import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'time' })
export class TimePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  /**
   * @param value time in seconds
   *
   * transforms seconds to format x years x days x hours x min
   */
  transform(value: number): string {
    const y = Math.floor(value / (3600 * 24 * 365));
    const d = Math.floor((value / (3600 * 24)) % 24);
    const h = Math.floor((value / 3600) % 60);
    const m = Math.floor((value / 60) % 60);

    const year = y > 0 ? y + this.translate.instant('MC_years') : '';
    const day = d > 0 ? d + this.translate.instant('MC_days') : '';
    const hour = h > 0 ? h + this.translate.instant('MC_hours') : '';
    const minute = m + this.translate.instant('MC_minutes');

    return year + day + hour + minute;
  }
}
